import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import DatePickerPL from "../../Components/DatePickerPL";

function AddAgreementProtocol(props) {
    const [user] = useContext(AuthContext);
    const [number, setNumber] = useState('');
    const [note, setNote] = useState('');
    const [contractor, setContractor] = useState(null);
    const [date, setDate] = useState('');
/*    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [percentage, setPercentage] = useState(100);*/
    const [contractors, setContractors] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {number: number, note: note, contractor_id: contractor.key,
            date: dbDate(date), venture_agreement_id: props.add?.venture_agreement_id};
        fetch(`/api/agreement/protocol`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddAgreementProtocol'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

/*    useEffect(() => {
        if (props?.total) {
            setNet(NumericMoneyFormat((parseFloat(props.total.net) * percentage) / 100));
            setGross(NumericMoneyFormat((parseFloat(props.total.gross) * percentage) / 100));
            setVat(props.total.vat);
        } else {
            setNet(0);
            setGross(0);
        }
    }, [percentage, props.total]);*/

    useEffect(() => {
        setNumber('');
        setNote('');
        setContractor({key: props.add?.contractor_id});
        setDate(new Date());
/*        setPercentage(100);*/
        const abortController = new AbortController();
        async function fetchContractors() {
            await fetch(`/api/contractor`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setContractors(data.map((item) => {
                        return {key: item.id, text: item.name};
                    }))
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchContractors();
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Protokół"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddAgreementProtocol'>
                <TextField required autoFocus label='Numer' value={number} onChange={(e) => setNumber(e.target.value || '')}/>
                <Dropdown
                    label="Wykonawca"
                    selectedKey={contractor ? contractor.key : undefined}
                    onChange={(e, item) => setContractor(item)}
                    placeholder="Wybierz z listy"
                    options={contractors}
                    disabled={props.add?.contractor_id !== undefined}
                />
                {/*{props?.total && <SpinButton
                    label={"% Kontraktu"}
                    labelPosition={"top"}
                    step={0.01}
                    incrementButtonAriaLabel={"+1"}
                    decrementButtonAriaLabel={"-1"}
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value || "")}
                />}*/}
                <TextField multiline label='Notatka' value={note} onChange={(e) => setNote(e.target.value || '')}/>
                <DatePickerPL
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                {/*<NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />*/}
            </form>
        </Panel>
    )
}

export default AddAgreementProtocol;